import { createRoutine } from 'redux-saga-routines'
import { IVitalState } from './vital.interafce'

const initialVitalState: IVitalState = {
  vitals: [],
  readings: [],
  deviceType: '',
  error: false,
  loading: false
}

export const getAllVitals = createRoutine('GET_ALL_VITALS')
export default function patient(state = initialVitalState, action: any) {
  switch (action.type) {
    case getAllVitals.TRIGGER: {
      return { ...state, loading: true, readings: [], vitals: [], error: false, success: false }
    }
    case getAllVitals.SUCCESS: {
      return {
        ...state,
        loading: false,
        success: true,
        vitals: action.payload.readings,
        readings: action.payload.data,
        deviceType: action.payload.deviceType,
        error: false
      }
    }

    case getAllVitals.FAILURE: {
      return {
        ...state,
        loading: false,
        success: true,
        error: true
      }
    }
      default:
        return state

  }
}
